import React, { useEffect, useMemo, useRef, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import messages from './Messages';
import Button from 'components/Button/Button';
import { ClassPhaseEditorClass } from './ClassPhaseEditorClass';
import CompanyMemberSelect from 'components/FileManager/ItemsViewer/Survey/SurveyEditor/CompanyMemberSelect/CompanyMemberSelect';
import LoadingCircleIndicator from 'components/LoadingCircleIndicator/LoadingCircleIndicator';
import Input from 'components/Input';
import Select from 'components/Select';
import { smartDateDuration } from 'utils/date';
import { IOption } from 'components/Select/Select';
import CKEditorField from 'components/CKEditorField';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { CkEditorBaseConfig } from 'components/CKEditorField/CKEditorField';
import notify from 'components/Notify';
import HoverIcon from 'components/HoverIcon';
import { blue, green, lightGreenSolid, red } from 'utils/style/colors';
import { generateRandomString } from 'utils/string';
import { isANumber, convertDigitToProperFormat } from 'utils/number';
import Collapsible from 'components/Collapsible';
import Badge from 'components/Badge';
import { CalendarField } from 'components/MyDatePicker/CalendarField';
import SelectWithPopover from 'components/Select/SelectWithPopover';
import { PDPClass, Term, Topic } from 'store/pdp/types';
import {
  HintIcon,
  HintText,
  QuestionHintBox,
} from 'components/FileManager/ItemsViewer/Survey/SurveyEditor/GeneralQuestion/styles';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import { withTitle } from 'components/withTitle';
import { Card } from '../CompanyRoles/styles';
import {
  AllowChoseGroup,
  ClassDocument,
  ClassPhaseProp,
  ClassTimeConflict,
  ICompany,
  ICompanyMember,
  ICompanyProviders,
} from 'store/companies/companiesTypes';
import { ITags, ITagView } from 'store/providers/providerTypes';
import { ISurveyItem, ISurveyView } from 'store/survey/surveyTypes';
import {
  createOrUpdateClassFn,
  checkClassTimeConflicts,
} from 'store/pdp/pdpSlice';
import { requireSeveralUserFn } from 'store/users/usersSlice';
import { item_createNewSurveyFn } from 'store/providers/providerSlice';
import { MoreSpan } from '../../../Profile/Panels/DocumentManager/styles';
import Dropdown from '../../../../components/Dropdown';
import ButtonGroup from '../../../../components/ButtonGroup';
import {
  CompanySelectorContainer,
  SelectedItemContainer,
  Wrapper,
} from './style';
import { notifyError } from '../../../../components/Notify/Notify';
import { useSafeNavigate } from '../../../../context/SafeNavigate/SafeNavigateProvider';
import { useSelector } from 'react-redux';
import { RootState, appDispatch } from '../../../../store/store';
import i18n from '../../../../i18n';

let disableForm = false;
interface IComponentProps {
  key: number;
  templateClass: PDPClass;
  company: ICompany;
  tags: ITags['data'];
  relatedProviders: ICompanyProviders;
  saveClass: (
    clazz: PDPClass,
    skipConflictCheck?: boolean
  ) => ReturnType<typeof createOrUpdateClassFn>;
  closeClass?: () => void;
  requireSeveralUser: (
    usersList: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
  companyMembers?: { [key: number]: ICompanyMember };
  createProviderSurvey: (
    item: ISurveyItem
  ) => ReturnType<typeof item_createNewSurveyFn>;
  updateSurvey: (
    surveyData: ISurveyView,
    providerSurveyItemData: ISurveyItem
  ) => Promise<any>;
  topic: Topic;
  token?: string;
  terms?: { [key: number]: { term?: Term } };
  pdpId: number;
}

const allGroupChangeOptions: IOption[] = [
  { value: 'No', label: messages.notAllowd },
  { value: 'AllowChange', label: messages.AllowChange },
];
export const ClassTemplateEditor: React.FC<IComponentProps> = ({
  templateClass,
  company,
  tags,
  relatedProviders,
  saveClass,
  closeClass,
  requireSeveralUser,
  companyMembers,
  createProviderSurvey,
  updateSurvey,
  topic,
  terms,
  token,
  pdpId,
}) => {
  const users = useSelector((state: RootState) => state.users.map);
  const { handleChangeDirty } = useSafeNavigate();
  const [initialRender, setInitialRender] = useState<boolean>(true);

  const [clazz, innerSetClass] = useState(templateClass);
  const setClass = (c: PDPClass) => {
    innerSetClass(c);
  };
  const activeCompanyMembers = useMemo(() => {
    return Object.values(companyMembers || {})
      .filter((it) => !it.inactive)
      .reduce((acc, cur) => {
        acc[cur.userId] = cur;
        return acc;
      }, {});
  }, [companyMembers]);
  const classStartDate = clazz.properties.phaseProps.reduce(
    (current, item) => {
      Object.values(item.phaseStartDates || {}).forEach((sd) => {
        if (sd && (!current || sd < current)) {
          current = sd;
        }
      });
      return current;
    },
    undefined as number | undefined
  );
  const classEndDate = clazz.properties.phaseProps.reduce(
    (current, item) => {
      Object.values(item.phaseEndDates || {}).forEach((ed) => {
        if (ed && (!current || ed > current)) {
          current = ed;
        }
      });
      return current;
    },
    undefined as number | undefined
  );

  const skipTemplateUpdate = useRef(false);

  const [selectedOption, setSelectedOption] = useState('basicSetting');
  useEffect(() => {
    disableForm = true;
    if (!skipTemplateUpdate.current) setClass(templateClass);
    setTimeout(() => {
      disableForm = false;
    }, 100);
    if (
      !templateClass.properties.phaseProps.find(
        (it) => `${it.phaseTagId}#${it.phaseStageId}` === selectedPhaseSteps
      )
    )
      setSelectedPhaseSteps('');
  }, [templateClass]);
  const selectedCompanyPdp = company.pdpPanels.find((el) => el.id === pdpId)!;
  const classPhases = useMemo(() => {
    const tagPhases = [] as ITagView[];
    Object.values(tags).forEach((t: ITagView) => {
      if (t.parentId === selectedCompanyPdp.properties.classPhaseParentTag)
        tagPhases.push(t);
    });
    return tagPhases.sort(
      (a, b) =>
        (a?.order || Number(a?.id) || 0) - (b?.order || Number(b?.id) || 0)
    );
  }, [templateClass]);
  const stages = new Set(
    clazz.properties.phaseProps.map((it) => it.phaseStageId!)
  );
  const multiStageTagIds = new Set(
    selectedCompanyPdp.properties.classPhaseDefaultProps
      ?.filter((it) => it.limitStateToOne !== true)
      .map((it) => it.phaseTagId)
  );
  const multiStageTags = classPhases.filter((it) =>
    multiStageTagIds.has(+it.id)
  );
  const singleStageTags = classPhases.filter(
    (it: ITagView) => !multiStageTagIds.has(+it.id)
  );

  const classLocations: IOption[] = useMemo(() => {
    const locations = [] as IOption[];
    Object.values(tags).forEach((t: ITagView) => {
      if (
        t.parentId === selectedCompanyPdp.properties.classLocations &&
        !t.deleted
      )
        locations.push({ value: t.id, label: t.text });
    });
    return locations;
  }, [templateClass]);
  const classHoldTypes: IOption[] = useMemo(() => {
    const holdTypes = [] as IOption[];
    Object.values(tags).forEach((t: ITagView) => {
      if (
        t.parentId === selectedCompanyPdp.properties.classHoldType &&
        !t.deleted
      )
        holdTypes.push({ value: t.id, label: t.text });
    });
    return holdTypes;
  }, [templateClass]);

  const newClazz = cloneDeep(clazz);
  const [saving, setSaving] = useState(false);
  const notInAnyGroup = Object.values(newClazz.participants).filter(
    (p) =>
      p.participantProps.status !== 'Dropped' &&
      newClazz.properties.classGroups.length > 1 &&
      (p.participantProps.group ?? '') === ''
  ).length;
  const [fastScheduleModalOpen, setFastScheduleModalOpen] = useState(
    false as false | number
  );
  const [fastScheduleInfo, setFastScheduleInfo] = useState({
    duration: {},
    startTime: {},
  });
  const [showAdvancedOptoins, setShowAdvancedOptoins] = useState(false);
  const [conflicts, setConflicts] = useState<any>(null);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [checkingConflicts, setCheckingConflicts] = useState(false);
  const schedule = () => {
    newClazz.properties.classGroups.forEach((g) => {
      if (fastScheduleInfo.startTime[g.key]) {
        let start = fastScheduleInfo.startTime[g.key];
        multiStageTags
          .sort((a, b) => (a.order ?? Number(a.id)) - (b.order ?? Number(b.id)))
          .forEach((ph) => {
            const end = start + fastScheduleInfo.duration[ph.id] * 1000 * 60;
            let phase = newClazz.properties.phaseProps.find(
              (it) =>
                it.phaseTagId === ph.id &&
                it.phaseStageId === fastScheduleModalOpen
            );
            if (!phase) {
              // @ts-expect-error it's ok
              phase = {
                phaseTagId: Number(ph.id),
                phaseEndDates: {},
                phaseStartDates: {},
                phaseStageId: +fastScheduleModalOpen,
                disabled: true,
              };
              newClazz.properties.phaseProps.push(phase!);
            }
            phase!.phaseStartDates[g.key] = end !== start ? start : undefined;
            phase!.phaseEndDates[g.key] = end !== start ? end : undefined;
            start = end;
          });
      }
    });
    setClass(newClazz);
    setFastScheduleModalOpen(false);
  };

  const handleCheckConflicts = async () => {
    setCheckingConflicts(true);
    try {
      const result = await appDispatch(
        checkClassTimeConflicts({ clazz: newClazz, pdpId })
      );
      if (result.response?.conflicts && result.response.conflicts.length > 0) {
        setConflicts(result.response);
        setShowConflictModal(true);
      } else {
        notify(
          i18n.t('noConflictsFound', { ns: 'companyManagement' }).toString()
        );
      }
    } catch (error) {
      notifyError(
        i18n.t('errorCheckingConflicts', { ns: 'companyManagement' }).toString()
      );
    } finally {
      setCheckingConflicts(false);
    }
  };
  const [selectedPhaseSteps, setSelectedPhaseSteps] = useState('');
  const buttonGroupOptions = {
    basicSetting: messages.basicSetting,
    userGrouping: `${messages.userGrouping}: ${messages.groupCount(newClazz.properties.classGroups.length)}`,
    phaseSteps: messages.phaseSteps,
  };

  const handleSelectedNavigationButtonGroup = (value: string) => {
    setSelectedOption(value);
  };

  const handleSelectedPhaseStepButtonGroup = (value: string) => {
    setSelectedPhaseSteps(value);
  };

  const withGradePhaseOptions = clazz.properties.phaseProps
    .filter(
      (it) =>
        tags[it.phaseTagId]?.text.includes('پس آزمون') || it.phaseWithGrade
    )
    .map((it) => {
      return {
        value: `${it.phaseTagId}_${it.phaseStageId}`,
        label:
          tags[it.phaseTagId]?.text +
          (stages.size > 1
            ? ' ' + messages.stageNumber(it.phaseStageId + 1)
            : ''),
      } as IOption;
    });

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    if (clazz !== templateClass) handleChangeDirty?.(true);
  }, [clazz]);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '4px',
          paddingBottom: '5px',
          borderBottom: `1px solid ${lightGreenSolid}`,
        }}
      >
        {
          <Modal
            title={messages.schedule(
              topic.properties.name,
              +fastScheduleModalOpen + 1
            )}
            onClose={() => setFastScheduleModalOpen(false)}
            isActive={isANumber(fastScheduleModalOpen)}
          >
            <div>
              <p>{messages.phaseDurations}</p>
              <div style={{ display: 'flex', gap: '10px' }}>
                {multiStageTags
                  .sort(
                    (a, b) =>
                      (a.order ?? Number(a.id)) - (b.order ?? Number(b.id))
                  )
                  .map((classPhase) => (
                    <>
                      <Input
                        id={classPhase.id?.toString() || ''}
                        type={'number'}
                        key={classPhase.id}
                        label={messages.duration(classPhase.text)}
                        value={fastScheduleInfo.duration[classPhase.id]}
                        onChange={(e) => {
                          const clone = cloneDeep(fastScheduleInfo);
                          clone.duration[classPhase.id] =
                            Number(e.target.value) || 0;
                          setFastScheduleInfo(clone);
                        }}
                      />
                    </>
                  ))}
              </div>

              <hr />
              <p>{messages.groupStartTimes}</p>

              <div style={{ display: 'flex', gap: '10px' }}>
                {clazz.properties.classGroups.map((group) => (
                  <CalendarField
                    key={group.key}
                    label={messages.groupStartTime(group.title)}
                    value={fastScheduleInfo.startTime[group.key]}
                    onChange={(value) => {
                      const clone = cloneDeep(fastScheduleInfo);
                      clone.startTime[group.key] = value;
                      setFastScheduleInfo(clone);
                    }}
                    withTime={true}
                  />
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  color={'green'}
                  onClick={schedule}
                  disabled={
                    !!multiStageTags.find(
                      (it) => !isANumber(fastScheduleInfo.duration[it.id])
                    )
                  }
                >
                  {messages.setSchedule}
                </Button>
              </div>
            </div>
          </Modal>
        }
        <h5>
          {topic.properties.name}{' '}
          {clazz.properties.corrective && `(${messages.corrective})`}{' '}
          {clazz.deleted && `(${messages.deleted})`}
        </h5>
        <Badge color={green}>
          {messages.classDuration} :{' '}
          {smartDateDuration(
            classStartDate ? new Date(classStartDate!) : undefined,
            classEndDate ? new Date(classEndDate!) : undefined,
            true
          )}
        </Badge>
        <div style={{ flexGrow: 1 }}> </div>
        <div>
          <Dropdown
            marginToTarget={0}
            placement="top-start"
            width={200}
            target={
              <div>
                <MoreSpan>
                  <Icon type="more-horizontal" />
                </MoreSpan>
              </div>
            }
          >
            <Dropdown.Menu>
              <Dropdown.MenuItem>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      confirm(
                        messages.confirmDeleteClass(
                          topic.properties.name,
                          clazz.relatedTermIds.reduce((current, termId) => {
                            const termName =
                              terms?.[termId].term?.properties?.name;
                            return (
                              current + (current.length ? ', ' : '') + termName
                            );
                          }, ''),
                          !!clazz.deleted
                        )
                      )
                    ) {
                      setSaving(true);
                      newClazz.deleted = !newClazz.deleted;
                      handleChangeDirty?.(false);
                      saveClass(newClazz)
                        .then(() => {
                          notify(
                            newClazz.deleted
                              ? messages.classDeleted
                              : messages.classRestored
                          );
                          if (newClazz.deleted) {
                            closeClass?.();
                          }
                        })
                        .catch((e) => {
                          notifyError(e);
                        })
                        .finally(() => {
                          setSaving(false);
                        });
                    }
                  }}
                >
                  <Icon
                    style={{ marginLeft: '5px' }}
                    type={newClazz.deleted ? 'rotate-ccw' : 'trash'}
                    color={red}
                  />{' '}
                  {newClazz.deleted ? messages.restore : messages.delete}
                </span>
              </Dropdown.MenuItem>
              <Dropdown.MenuItem>
                <span
                  onClick={() => {
                    setShowAdvancedOptoins(!showAdvancedOptoins);
                  }}
                >
                  <Icon
                    style={{ marginLeft: '5px' }}
                    type={showAdvancedOptoins ? 'eye-off' : 'settings'}
                  />{' '}
                  {showAdvancedOptoins
                    ? messages.hideAdvancedOptoins
                    : messages.showAdvancedOptions}
                </span>
              </Dropdown.MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button
            type="button"
            disabled={checkingConflicts}
            loading={checkingConflicts}
            color="blue-outline"
            onClick={handleCheckConflicts}
          >
            <Icon type="clock" style={{ marginRight: '5px' }} />
            {i18n.t('checkConflicts', { ns: 'companyManagement' }).toString()}
          </Button>
          <Button
            color="green"
            loading={saving}
            onClick={() => {
              setSaving(true);
              newClazz.startDate = classStartDate;
              newClazz.endDate = classEndDate;
              handleChangeDirty?.(false);
              saveClass(newClazz)
                .then(() => {
                  notify(messages.saved);
                })
                .catch((e) => {
                  notifyError(e);
                  if (
                    e?.data?.message ===
                    'class.has.time.conflicts.with.existing.classes'
                  ) {
                    setConflicts(e.data.object);
                    setShowConflictModal(true);
                  } else {
                    notifyError(e);
                  }
                })
                .finally(() => {
                  setSaving(false);
                  handleChangeDirty?.(false);
                });
            }}
          >
            {messages.save}
          </Button>
        </div>
      </div>
      <div
        style={{
          flexGrow: 1,
          height: 'calc(100% - 10rem)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <ButtonGroup
          items={buttonGroupOptions}
          selected={selectedOption}
          onSelect={handleSelectedNavigationButtonGroup}
          style={{ margin: '1rem 0', flexShrink: 0 }}
        />
        {selectedOption === 'basicSetting' ? (
          <div
            style={{
              overflow: 'auto',
              flexGrow: 1,
              flexShrink: 1,
              maxHeight: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                overflow: 'visible',
              }}
            >
              <CompanySelectorContainer style={{ flex: '1' }}>
                {companyMembers ? (
                  withTitle(
                    <CompanyMemberSelect
                      companyMembers={activeCompanyMembers}
                      onSelectUser={(userIds: number[]) => {
                        newClazz.managerUserId = userIds[0];
                        setClass({ ...newClazz });
                      }}
                      label={messages.classAdmin}
                      placeholder={''}
                      selected={
                        newClazz.managerUserId ? [newClazz.managerUserId] : []
                      }
                      multiSelect={false}
                      requireSeveralUser={requireSeveralUser}
                    />,
                    messages.instructorHint
                  )
                ) : (
                  <LoadingCircleIndicator />
                )}
              </CompanySelectorContainer>
              {newClazz.properties.teacher ? (
                <Input
                  id="teacher"
                  style={{ width: '200px' }}
                  type="text"
                  label={messages.teacherName}
                  value={newClazz.properties.teacher}
                  onChange={(e) => {
                    newClazz.properties.teacher = e.target.value;
                    setClass({ ...newClazz });
                  }}
                />
              ) : (
                <CompanySelectorContainer style={{ flex: '1' }}>
                  {companyMembers ? (
                    withTitle(
                      <CompanyMemberSelect
                        companyMembers={companyMembers}
                        onSelectUser={(userIds: number[]) => {
                          newClazz.teacherUserId = userIds[0];
                          setClass({ ...newClazz });
                        }}
                        label={messages.teacherName}
                        allowAdd={true}
                        placeholder={''}
                        selected={
                          newClazz.teacherUserId ? [newClazz.teacherUserId] : []
                        }
                        company={company}
                        multiSelect={false}
                        requireSeveralUser={requireSeveralUser}
                      />,
                      messages.teacherHint
                    )
                  ) : (
                    <LoadingCircleIndicator />
                  )}
                </CompanySelectorContainer>
              )}
              <Select
                onChangeValues={(values) => {
                  newClazz.properties.holdType =
                    Number(values[0]?.value) || undefined;
                  setClass({ ...newClazz });
                }}
                options={classHoldTypes}
                label={messages.holdType}
                values={classHoldTypes.filter(
                  (it) => it.value === newClazz.properties.holdType
                )}
                allowRemove={true}
              />
              <Select
                onChangeValues={(values) => {
                  newClazz.properties.location =
                    Number(values[0]?.value) || undefined;
                  setClass({ ...newClazz });
                }}
                options={classLocations}
                label={messages.location}
                values={classLocations.filter(
                  (it) => it.value === newClazz.properties.location
                )}
                allowRemove={true}
              />
              <Input
                id={'budget'}
                type="number"
                onChange={(e) => {
                  newClazz.properties.budget =
                    Number(e.target.value) || undefined;
                  setClass({ ...newClazz });
                }}
                value={newClazz.properties.budget || 0}
                label={messages.budget}
                placeholder={messages.currency}
              />
              <Input
                id={'trainingHour'}
                type="number"
                onChange={(e) => {
                  newClazz.properties.trainingHour =
                    Number(e.target.value) +
                      (newClazz.properties.trainingHour || 0) -
                      Math.floor(newClazz.properties.trainingHour || 0) ||
                    undefined;
                  setClass({ ...newClazz });
                }}
                value={Math.floor(newClazz.properties.trainingHour || 0)}
                label={messages.trainingHour}
                placeholder={messages.hour}
              />
              <Input
                id={'trainingMinute'}
                type="number"
                onChange={(e) => {
                  if (
                    Number(e.target.value) >= 0 &&
                    Number(e.target.value) <= 60
                  ) {
                    newClazz.properties.trainingHour =
                      Math.floor(newClazz.properties.trainingHour || 0) +
                        Number(e.target.value) / 60 || undefined;
                    setClass({ ...newClazz });
                  }
                }}
                value={(
                  ((newClazz.properties.trainingHour || 0) -
                    Math.floor(newClazz.properties.trainingHour || 0)) *
                  60
                ).toFixed(0)}
                min={0}
                max={60}
                label={messages.minute}
                placeholder={messages.minute}
                style={{ width: '11rem' }}
              />
              {showAdvancedOptoins && (
                <Input
                  id={'isCorrective'}
                  type="checkbox"
                  onChange={(e) => {
                    newClazz.properties.corrective =
                      e.target.checked || undefined;
                    setClass({ ...newClazz });
                  }}
                  checked={newClazz.properties.corrective}
                  label={messages.isClassCorrective}
                />
              )}
            </div>
            <Collapsible
              isOpen={clazz.properties.autoApproveProps.autoApproveEnabled}
              header={
                <Input
                  id="autoapprove"
                  type="checkbox"
                  checked={clazz.properties.autoApproveProps.autoApproveEnabled}
                  onChange={(e) => {
                    newClazz.properties.autoApproveProps.autoApproveEnabled =
                      e.target.checked;
                    if (
                      newClazz.properties.autoApproveProps.autoApproveEnabled &&
                      !isANumber(
                        newClazz.properties.autoApproveProps.approvePercent
                      )
                    ) {
                      newClazz.properties.autoApproveProps.approvePercent = 80;
                    }
                    setClass(newClazz);
                  }}
                  label={messages.autoApproveAfterExam}
                />
              }
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                  alignItems: 'stretch',
                }}
              >
                <p>{messages.autoGradingHint}</p>
                <SelectWithPopover
                  onChangeValues={(selectedItems) => {
                    const phaseList = selectedItems.map((item) => {
                      const [phaseTagId, stageId] = item.value
                        .toString()
                        .split('_')
                        .map((it) => Number(it));
                      return { phaseTagId, stageId };
                    });
                    newClazz.properties.autoApproveProps.phaseList = phaseList;
                    setClass(newClazz);
                  }}
                  options={withGradePhaseOptions}
                  values={withGradePhaseOptions.filter((it) =>
                    clazz.properties.autoApproveProps.phaseList?.some(
                      (phase) =>
                        it.value === `${phase.phaseTagId}_${phase.stageId}`
                    )
                  )}
                  allowRemove={true}
                  multiChoice={true}
                  label={messages.gradingBasedOn}
                />
                <Input
                  label={messages.approvedGrade}
                  id={'approvePercent'}
                  type={'number'}
                  value={clazz.properties.autoApproveProps.approvePercent}
                  onChange={(e) => {
                    newClazz.properties.autoApproveProps.approvePercent =
                      Number(e.target.value);
                    setClass(newClazz);
                  }}
                />
              </div>
            </Collapsible>
            <CKEditorField
              onChange={(data: string) => {
                if (!disableForm) {
                  newClazz.properties.description = data;
                  setClass({ ...newClazz });
                }
              }}
              // editor={ClassicEditor}
              data={newClazz.properties.description}
              dir="rtl"
              label={messages.classDescription}
              config={CkEditorBaseConfig(token)}
            />{' '}
          </div>
        ) : selectedOption === 'userGrouping' ? (
          <div
            style={{
              overflow: 'auto',
              flexGrow: 1,
              flexShrink: 1,
              maxHeight: '100%',
            }}
          >
            {notInAnyGroup > 0 && (
              <QuestionHintBox color={red}>
                <HintIcon type="alert-circle" color={red} />
                <HintText style={{ color: red }}>
                  <span>{messages.notInAnyGroup(notInAnyGroup)}</span>
                </HintText>
              </QuestionHintBox>
            )}
            <hr />
            {messages.groupHint}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              {newClazz.properties.classGroups?.map((g, index) => {
                return (
                  <Card
                    key={g.key}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: ' 10px',
                      width: '100%',
                      flexWrap: 'wrap',
                      alignItems: 'flex-start',
                      flexDirection: 'column',
                      flexGrow: 0,
                    }}
                  >
                    <Input
                      label={messages.groupTitle}
                      id={g.key}
                      type={'text'}
                      value={g.title}
                      onChange={(e) => {
                        newClazz.properties.classGroups[index].title =
                          e.target.value;
                        setClass(newClazz);
                      }}
                    />
                    <Select
                      containerStyle={{ width: '200px' }}
                      onChangeValues={(values) => {
                        newClazz.properties.classGroups[index].holdType =
                          Number(values[0]?.value) || undefined;
                        setClass({ ...newClazz });
                      }}
                      options={classHoldTypes}
                      label={messages.holdType}
                      values={classHoldTypes.filter(
                        (it) => it.value === g.holdType
                      )}
                      placeholder={
                        messages.default +
                        ': ' +
                        (classHoldTypes.filter(
                          (it) => it.value === newClazz.properties.holdType
                        )?.[0]?.label ?? '-')
                      }
                      allowRemove={true}
                    />
                    <Select
                      containerStyle={{ width: '200px' }}
                      onChangeValues={(values) => {
                        newClazz.properties.classGroups[index].location =
                          Number(values[0]?.value) || undefined;
                        setClass({ ...newClazz });
                      }}
                      options={classLocations}
                      label={messages.location}
                      values={classLocations.filter(
                        (it) => it.value === g.location
                      )}
                      placeholder={
                        messages.default +
                        ': ' +
                        (classLocations.filter(
                          (it) => it.value === newClazz.properties.location
                        )?.[0]?.label ?? '-')
                      }
                      allowRemove={true}
                    />
                    <CompanyMemberSelect
                      wrapperStyle={{ width: '100%' }}
                      companyMembers={companyMembers}
                      onSelectUser={(userIds: number[]) => {
                        newClazz.properties.classGroups[index].teacherUserId =
                          userIds[0];
                        setClass({ ...newClazz });
                      }}
                      label={
                        messages.teacherName +
                        (!g.teacherUserId ? ` (${messages.classDefalut})` : '')
                      }
                      allowAdd={true}
                      placeholder={''}
                      selected={
                        g.teacherUserId
                          ? [g.teacherUserId]
                          : newClazz.teacherUserId
                            ? [newClazz.teacherUserId]
                            : []
                      }
                      company={company}
                      multiSelect={false}
                      requireSeveralUser={requireSeveralUser}
                    />
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Badge color={blue} style={{}}>
                        {messages.memberCount(
                          Object.values(newClazz.participants).filter(
                            (p) =>
                              p.participantProps.status !== 'Dropped' &&
                              (newClazz.properties.classGroups.length < 2 ||
                                p.participantProps.group === g.key)
                          ).length
                        )}
                      </Badge>
                      <HoverIcon
                        type={'trash'}
                        color={red}
                        onClick={() => {
                          const foundParticipant = Object.values(
                            newClazz.participants
                          ).filter(
                            (p) => p.participantProps.group === g.key
                          ).length;
                          if (
                            !foundParticipant ||
                            confirm(
                              messages.removeGroup(foundParticipant, g.title)
                            )
                          ) {
                            newClazz.properties.classGroups.splice(index, 1);
                            setClass(newClazz);
                          }
                        }}
                      />
                    </div>
                  </Card>
                );
              })}
              <div style={{ width: '100%' }}>
                <Button
                  color={'green'}
                  onClick={() => {
                    if (!newClazz.properties.classGroups)
                      newClazz.properties.classGroups = [];
                    newClazz.properties.classGroups.push({
                      key: generateRandomString(4),
                      title: `گروه ${convertDigitToProperFormat(newClazz.properties.classGroups.length + 1)}`,
                    });
                    setClass(newClazz);
                  }}
                >
                  <Icon type={'plus'} style={{ marginLeft: '5px' }} />
                  {messages.addGroup}
                </Button>
              </div>
            </div>
            {clazz.properties.classGroups.length > 1 && (
              <Collapsible
                nested={true}
                customHeaderStyle={{ flexGrow: 1 }}
                hideChevron
                header={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <p>{messages.allowChoseGroupByParticipants}</p>
                    <SelectWithPopover
                      onChangeValues={(v) => {
                        newClazz.properties.allowChooseGroup =
                          v[0].value.toString() as AllowChoseGroup;
                        setClass(newClazz);
                      }}
                      options={allGroupChangeOptions}
                      values={allGroupChangeOptions.filter((it) => {
                        return (
                          it.value === newClazz.properties.allowChooseGroup
                        );
                      })}
                      allowRemove={false}
                    />
                  </div>
                }
                isOpen={newClazz.properties.allowChooseGroup !== 'No'}
              >
                <div style={{ display: 'flex', gap: '10px' }}>
                  {newClazz.properties.allowChooseGroup !== 'No' && (
                    <>
                      <CalendarField
                        value={
                          (newClazz.properties.groupChooseStartDate &&
                            Number(newClazz.properties.groupChooseStartDate)) ||
                          undefined
                        }
                        onChange={(value: number | null) => {
                          const oldStartDate =
                            newClazz.properties.groupChooseStartDate;
                          newClazz.properties.groupChooseStartDate = value;
                          if (
                            newClazz.properties.groupChooseEndDate &&
                            newClazz.properties.groupChooseStartDate! >
                              newClazz.properties.groupChooseEndDate
                          )
                            if (
                              oldStartDate &&
                              newClazz.properties.groupChooseEndDate
                            )
                              newClazz.properties.groupChooseEndDate +=
                                newClazz.properties.groupChooseStartDate! -
                                oldStartDate;
                            else
                              newClazz.properties.groupChooseStartDate =
                                newClazz.properties.groupChooseEndDate -
                                7 * 24 * 60 * 60 * 1000;
                          setClass({ ...newClazz });
                        }}
                        placeholder={messages.unknown}
                        withTime={true}
                        label={messages.groupSelectStartDate}
                      />
                      <CalendarField
                        value={
                          (newClazz.properties.groupChooseEndDate &&
                            Number(newClazz.properties.groupChooseEndDate)) ||
                          undefined
                        }
                        onChange={(value: number | null) => {
                          newClazz.properties.groupChooseEndDate = value;
                          if (
                            newClazz.properties.groupChooseStartDate &&
                            newClazz.properties.groupChooseStartDate >
                              newClazz.properties.groupChooseEndDate!
                          )
                            newClazz.properties.groupChooseEndDate =
                              newClazz.properties.groupChooseStartDate +
                              7 * 24 * 60 * 60 * 1000;
                          setClass({ ...newClazz });
                        }}
                        placeholder={messages.unknown}
                        withTime={true}
                        label={messages.groupSelectEndDate}
                      />
                    </>
                  )}
                </div>
                {newClazz.properties.allowChooseGroup !== 'No' &&
                  newClazz.properties.groupChooseStartDate && (
                    <QuestionHintBox color={blue}>
                      <HintIcon type="message-square" color={blue} />
                      <HintText style={{ color: blue }}>
                        <span>{messages.groupChooseReminderNotice}</span>
                      </HintText>
                    </QuestionHintBox>
                  )}
                {newClazz.properties.allowChooseGroup !== 'No' && (
                  <CKEditorField
                    onChange={(data: string) => {
                      if (!disableForm) {
                        newClazz.properties.groupChooseDescription = data;
                        setClass({ ...newClazz });
                      }
                    }}
                    // editor={ClassicEditor}
                    data={newClazz.properties.groupChooseDescription}
                    dir="rtl"
                    label={messages.groupChooseDescription}
                    config={CkEditorBaseConfig()}
                  />
                )}
              </Collapsible>
            )}
          </div>
        ) : (
          // <Collapsible
          //   style={{ width: '100%' }}
          //   nested={true}
          //   isOpen={true}
          //   header={
          //     <div
          //       style={{
          //         display: 'flex',
          //         justifyContent: 'space-between',
          //         width: '100%',
          //         overflow: 'auto',
          //       }}
          //     >
          //       {' '}
          //       <span>
          //         {messages.userGrouping}:{' '}
          //         {messages.groupCount(newClazz.properties.classGroups.length)}
          //       </span>{' '}
          //     </div>
          //   }
          // >
          //
          // </Collapsible>
          <Wrapper>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                maxHeight: 'calc( 100% - 5rem )',
                overflow: 'auto',
              }}
            >
              {multiStageTags.length > 0 && (
                <>
                  {[...stages].map((stage, index) => (
                    <div style={{ position: 'relative' }} key={stage}>
                      <div style={{ display: 'flex' }}>
                        <div style={{ flex: 1 }}>
                          {messages.stageNumber(stage + 1)}
                        </div>
                        <HoverIcon
                          type="calendar"
                          color={blue}
                          onClick={() => {
                            setFastScheduleModalOpen(stage);
                          }}
                        />
                        {index >= 1 && index === stages.size - 1 && (
                          <HoverIcon
                            type="x"
                            color={red}
                            onClick={() => {
                              const clone = cloneDeep(clazz);
                              clone.properties.phaseProps =
                                clone.properties.phaseProps.filter(
                                  (it) =>
                                    it.phaseStageId !== stage ||
                                    it.limitStateToOne === true
                                );
                              if (
                                Number(selectedPhaseSteps.split('#')[1]) ===
                                stage
                              ) {
                                setSelectedPhaseSteps('');
                              }
                              setClass(clone);
                            }}
                          />
                        )}
                      </div>
                      <ButtonGroup
                        items={multiStageTags.reduce((acc, currentPhase) => {
                          const found = clazz.properties.phaseProps.find(
                            (it) =>
                              it.phaseTagId === currentPhase.id &&
                              it.phaseStageId === stage
                          );
                          acc[`${currentPhase.id}#${stage}`] = (
                            <div style={{ textAlign: 'right' }}>
                              {` ${found?.disabled === false ? (found?.adminUsers?.length ? '👨🏻‍' : '✅') : ''} ${currentPhase.text}`}
                            </div>
                          );
                          return acc;
                        }, {})}
                        selected={selectedPhaseSteps}
                        onSelect={handleSelectedPhaseStepButtonGroup}
                        vertical={true}
                      />
                    </div>
                  ))}
                  <Button
                    onClick={() => {
                      let nextStage = 0;
                      stages.forEach((it) => {
                        if (nextStage <= it) nextStage = it + 1;
                      });
                      const clone = cloneDeep(clazz);
                      const newPhases = cloneDeep(
                        selectedCompanyPdp.properties.classPhaseDefaultProps!.filter(
                          (it) => {
                            return it.limitStateToOne !== true;
                          }
                        )
                      );
                      newPhases.forEach((it) => {
                        it.phaseStageId = nextStage;
                      });
                      clone.properties.phaseProps.push(...newPhases);
                      setClass(clone);
                    }}
                  >
                    {' '}
                    {messages.addStage}
                  </Button>
                </>
              )}
              <div style={{ flexShrink: 0 }}>
                <ButtonGroup
                  items={singleStageTags.reduce((acc, currentPhase) => {
                    const found = clazz.properties.phaseProps.find(
                      (it) => it.phaseTagId === currentPhase.id
                    );
                    acc[`${currentPhase.id}#0`] = (
                      <div style={{ textAlign: 'right' }}>
                        {` ${found?.disabled === false ? (found?.adminUsers?.length ? '👨🏻‍' : '✅') : ''} ${currentPhase.text}`}
                      </div>
                    );
                    return acc;
                  }, {})}
                  selected={selectedPhaseSteps}
                  onSelect={handleSelectedPhaseStepButtonGroup}
                  vertical={true}
                />
              </div>
            </div>
            {selectedPhaseSteps.length > 0 && (
              <SelectedItemContainer>
                {(() => {
                  const selectedPhaseStageId = Number(
                    selectedPhaseSteps.split('#')[1]
                  );
                  const selectedPhaseTagId = Number(
                    selectedPhaseSteps.split('#')[0]
                  );
                  const phase = tags[selectedPhaseTagId];
                  const phaseInfo =
                    clazz.properties.phaseProps.find((it) => {
                      return (
                        it.phaseTagId === selectedPhaseTagId &&
                        it.phaseStageId === selectedPhaseStageId
                      );
                    }) ||
                    ({
                      ...(selectedCompanyPdp.properties.classPhaseDefaultProps?.find(
                        (it) => {
                          return (
                            it.phaseTagId === selectedPhaseTagId &&
                            it.phaseStageId === selectedPhaseStageId
                          );
                        }
                      ) || {}),
                      phaseTagId: phase.id,
                      disabled: true,
                      phaseStageId: selectedPhaseStageId,
                    } as ClassPhaseProp);
                  return (
                    <div>
                      <ClassPhaseEditorClass
                        phaseInfo={{ ...phaseInfo }}
                        clazz={clazz}
                        hideAdvancedOptions={!showAdvancedOptoins}
                        updatePhase={(classPhase: ClassPhaseProp) => {
                          newClazz.properties.phaseProps =
                            newClazz.properties.phaseProps?.filter(
                              (it) =>
                                it.phaseTagId !== classPhase.phaseTagId ||
                                it.phaseStageId !== classPhase.phaseStageId
                            ) || [];
                          newClazz.properties.phaseProps = [
                            ...newClazz.properties.phaseProps,
                            classPhase,
                          ];
                          setClass({ ...newClazz });
                        }}
                        tag={phase}
                        company={company}
                        topic={topic}
                        isTemplate={false}
                        relatedProviders={relatedProviders}
                        createProviderSurvey={createProviderSurvey}
                        updateSurvey={updateSurvey}
                        fastSaveSurveyItemInPhase={(classDocument, phase) => {
                          const toSave = cloneDeep(templateClass);
                          let toUpdatePhase = toSave.properties.phaseProps.find(
                            (it) =>
                              it.phaseStageId === phase.phaseStageId &&
                              it.phaseTagId === phase.phaseTagId
                          );
                          if (!toUpdatePhase) {
                            toUpdatePhase = {
                              phaseTagId: phase.phaseTagId,
                              phaseStageId: phase.phaseStageId,
                              phaseDocuments: [] as ClassDocument[],
                            } as ClassPhaseProp;
                            toSave.properties.phaseProps.push(toUpdatePhase);
                          }
                          toUpdatePhase!.phaseDocuments.push(classDocument);
                          skipTemplateUpdate.current = true;
                          handleChangeDirty?.(false);
                          return saveClass(toSave, true).finally(() => {
                            setTimeout(() => {
                              skipTemplateUpdate.current = false;
                            }, 100);
                          });
                        }}
                        classPhases={classPhases}
                        isOpen={true}
                        companyMembers={companyMembers}
                        users={users}
                        pdpId={pdpId}
                      />
                    </div>
                  );
                })()}
              </SelectedItemContainer>
            )}
          </Wrapper>
        )}
      </div>
      {showConflictModal && (
        <Modal
          width="50vw"
          height="auto"
          title={i18n.t('classTimeConflictCheck', { ns: 'companyManagement' })}
          onClose={() => setShowConflictModal(false)}
          isActive={showConflictModal}
        >
          <div style={{ maxHeight: '60vh', overflow: 'scroll' }}>
            <p>
              {i18n
                .t('classHasConflicts', { ns: 'companyManagement' })
                .toString()}
            </p>
            {conflicts?.conflicts?.map(
              (conflict: ClassTimeConflict, index: number) => (
                <div
                  key={index}
                  style={{
                    marginBottom: '10px',
                    padding: '10px',
                    border: '1px solid #ccc',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    window.open(
                      `/t/${company.id}/pdp/${selectedCompanyPdp.id}/terms/${conflict.termIds[0]}/class/${conflict.classId}`,
                      '_blank'
                    );
                  }}
                >
                  <strong>{conflict.className}</strong>
                  {conflict.groupTitle && (
                    <div>
                      <>
                        {i18n.t('group', { ns: 'companyManagement' })}:{' '}
                        {conflict.groupTitle}
                      </>
                    </div>
                  )}
                  <div>
                    {i18n
                      .t('conflictTime', { ns: 'companyManagement' })
                      .toString()}
                    :{' '}
                    {smartDateDuration(
                      conflict.conflictStartDate,
                      conflict.conflictEndDate,
                      true,
                      true
                    )}
                  </div>
                </div>
              )
            )}
          </div>
          <div
            style={{
              display: 'flex',
              gap: '10px',
              justifyContent: 'flex-end',
              marginTop: '20px',
            }}
          >
            {selectedCompanyPdp?.properties?.checkClassTimeConflict?.enabled ===
              'Warning' && (
              <Button
                color="red"
                loading={saving}
                onClick={() => {
                  setSaving(true);
                  newClazz.startDate = classStartDate;
                  newClazz.endDate = classEndDate;
                  handleChangeDirty?.(false);
                  saveClass(newClazz, true)
                    .then(() => {
                      notify(messages.saved);
                    })
                    .catch((e) => {
                      notifyError(e);
                    })
                    .finally(() => {
                      setSaving(false);
                      handleChangeDirty?.(false);
                      setShowConflictModal(false);
                    });
                }}
              >
                {i18n.t('saveAnyway', { ns: 'companyManagement' }).toString()}
              </Button>
            )}
            <Button color={'white'} onClick={() => setShowConflictModal(false)}>
              {i18n.t('cancel', { ns: 'companyManagement' }) as string}
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};
